import React from "react";
import { Button, Col, Form, Modal, Row, OverlayTrigger } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import {
  GetWellnessDetails,
  AddWellness,
  DeleteWellness,
  UpdateWellness,
} from "../../../../api/User/ACG/WellnessApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter rate"),
  uW_Factor: Yup.number()
    // .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter UW factor"),
});

const Wellness = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "Wellness Program Completion Rate",
      field: "rate",
    },
    {
      title: "UW Factor",
      field: "uW_Factor",
      render: (rowData) => (+rowData.uW_Factor  * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.uW_Factor  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },

    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getWellnessDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getWellnessDetailsData();
  }, []);

  const getWellnessDetailsData = () => {
    setIsLoading(true);
    GetWellnessDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { rate, uW_Factor } = values;
    const payload = {
      id: 0,
      rate: +rate,
      uW_Factor: +uW_Factor,
    };

    if (witchAction === "add") {
      AddWellness(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateWellness(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Wellness Program
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteWellness(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                rate: selectedRowData?.rate ?? 0,
                uW_Factor: selectedRowData?.uW_Factor ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <CustomInputField
                          label="Wellness Program Completion Rate"
                          name="rate"
                          maxLength={10}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Row>
                      <Row className="mb-2 gap-3">
                        <CustomInputField
                          label="UW Factor"
                          name="uW_Factor"
                          maxLength={10}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Wellness Program
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Wellness;
